import { getEndPoint } from './getEndPoint'
export const searchBlogPosts = term => getEndPoint('wp/v2/posts?search=' + term)
